import React from 'react';

const Field = ({ name, value }: { name: string; value: string }) => {
  return (
    <div className="grid grid-cols-2 border-b border-solid border-b-gray-100 [&:last-child]:border-0 [&:nth-child(2n)]:bg-gray-50">
      <span className="w-full px-4 py-3">{name}</span>
      <span className="w-full px-4 py-3">{value}</span>
    </div>
  );
};
export default Field;
